import { Input } from '@/ui';

interface NumberFieldProps {
  id: string;
  label: string;
  value: number | string | undefined;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
  placeholder?: string;
  description?: string;
}

const NumberField = ({
  id,
  label,
  value,
  onChange,
  error,
  disabled,
  placeholder,
  description
}: NumberFieldProps) => (
  <div className="flex flex-col gap-1">
    <Input
      id={id}
      type="number"
      label={label}
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      placeholder={placeholder}
      helpText={description}
    />
    {error && <p className="text-sm text-red-500 dark:text-red-400">{error}</p>}
  </div>
);

export default NumberField;
